import styled from "styled-components";

export const Heading = styled.div`
  text-align: center;
  color: #000;
  font-family: Poppins;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0.44em;
`;
export const Info = styled.div`
  color: #666;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 1.31em;
`;
export const Edit = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  position: absolute;
  right: 1.5em;
  top: 1.13em;
  cursor: pointer;
  z-index: 100;
 
  img{
    cursor: pointer ;
  }
  
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    right: 1em;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    right: 1.69em;
  }
`;
export const Image = styled.div`

  margin: 0 auto;
  /* border-radius: 50%; */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const ImageContainer = styled.div`
  width: 19.375rem;
  height: 9.5rem;
  border-radius: 1.125rem;
  background: #f4f4f4;
  margin-bottom: 1.94em;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const Header = styled.div`
  color: #000;
  font-family: Poppins;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0.75em;
  text-align: center;
`;
export const HeroImageContainer = styled.div`
  position: relative;
  width: 19.375rem;
  height: 7.375rem;
  border-radius: 1.125rem;
  background: #f2f9ff;
  margin-bottom: 2.06em;
   cursor: pointer;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const ModalCard = styled.span`
  width: 24.375rem;
  min-height: 36.6875rem;
  background: #fff;
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
  position: relative;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 20.375rem;
  }
`;
